module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.questionIndex === _vm.quiz.questions.length && _vm.flag_end !== true),
      expression: "questionIndex === quiz.questions.length && flag_end !== true"
    }],
    staticClass: "container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 centered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "icon-addon addon-md"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email *",
      "id": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "fa fa-envelope",
    attrs: {
      "for": "email",
      "rel": "tooltip",
      "title": "Email"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 centered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "icon-addon addon-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.full_name),
      expression: "user.full_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nom",
      "id": "full_name"
    },
    domProps: {
      "value": (_vm.user.full_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.full_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "fa fa-user",
    attrs: {
      "for": "full_name",
      "rel": "tooltip",
      "title": "Nom complet"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 centered"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('small', [_c('u', {
    staticClass: "hand",
    on: {
      "click": function($event) {
        _vm.setEnd()
      }
    }
  }, [_vm._v("Montre moi juste les réponses")])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-cred btn-lg btn-block",
    attrs: {
      "type": "button",
      "disabled": _vm.user.email === '' || _vm.errors.has('email')
    },
    on: {
      "click": function($event) {
        _vm.setEnd()
      }
    }
  }, [_vm._v("Voir les résultats! ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container add-padding"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.questionIndex !== _vm.quiz.questions.length),
      expression: "questionIndex !== quiz.questions.length"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 centered countdown round"
  }, [_c('h4', [_vm._v(_vm._s(_vm.quiz.title))])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._l((_vm.quiz.questions), function(question, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.questionIndex),
        expression: "index === questionIndex"
      }],
      staticClass: "col-md-8 frb-group"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('p', {
      staticClass: "col-md-12"
    }, [_vm._v("Question " + _vm._s(_vm.questionIndex + 1) + "/" + _vm._s(_vm.quiz.questions.length) + " : ")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('h5', {
      domProps: {
        "innerHTML": _vm._s(question.text)
      }
    })])]), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, _vm._l((question.responses), function(response, count) {
      return _c('div', {
        staticClass: "form-check frb frb-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.userResponses[index]),
          expression: "userResponses[index]"
        }],
        staticClass: "form-check-input",
        attrs: {
          "type": "radio",
          "name": _vm.radioId(index),
          "id": _vm.radioId(index + '' + count)
        },
        domProps: {
          "value": response.score,
          "checked": _vm._q(_vm.userResponses[index], response.score)
        },
        on: {
          "__c": function($event) {
            var $$exp = _vm.userResponses,
              $$idx = index;
            if (!Array.isArray($$exp)) {
              _vm.userResponses[index] = response.score
            } else {
              $$exp.splice($$idx, 1, response.score)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "form-check-label",
        attrs: {
          "for": _vm.radioId(index + '' + count)
        }
      }, [_c('span', {
        staticClass: "frb-description"
      }, [_c('h6', [_vm._v(_vm._s(response.text))])])])])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 clearfix"
    }, [(_vm.questionIndex > 0) ? _c('button', {
      staticClass: "btn btn-cred btn-round hand alignleft",
      on: {
        "click": _vm.prev
      }
    }, [_vm._v("\n                                préc.\n                            ")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-cred btn-round hand alignright",
      attrs: {
        "disabled": _vm.userResponses[index] == null
      },
      on: {
        "click": _vm.next
      }
    }, [_vm._v("\n                                suiv. \n                            ")])])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.questionIndex),
        expression: "index === questionIndex"
      }],
      staticClass: "col-md-4"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": question.img
      }
    })])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag_end !== false),
      expression: "flag_end !== false"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 centered"
  }, [_c('img', {
    staticClass: "img-medals",
    attrs: {
      "src": _vm.rank
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "countdown"
  }, [_vm._v("\n                    Total score: " + _vm._s(_vm.score()) + " / " + _vm._s(_vm.quiz.questions.length * 2) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag_end !== false),
      expression: "flag_end !== false"
    }],
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-12 centered"
  }, [_vm._v(_vm._s(_vm.result))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag_end !== false),
      expression: "flag_end !== false"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 centered"
  }, [_vm._v("\n                    Tu as aimé ? Fais le savoir en partageant <3.\n                ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag_end !== false),
      expression: "flag_end !== false"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 centered"
  }, [_c('div', {
    staticClass: "fb-share-button",
    attrs: {
      "data-href": _vm.fb_link,
      "data-layout": "button_count",
      "data-size": "large",
      "data-mobile-iframe": "true"
    }
  }, [_c('a', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fchaperon.me%2F%23%2Fquizz&src=sdkpreparse"
    }
  }, [_vm._v("Partager")])])])]), _vm._v(" "), _vm._m(6)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner2"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "banner__caption2"
  }, [_c('h1', [_vm._v("Quizz")]), _c('br')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-container",
    attrs: {
      "id": "background-container"
    }
  }, [_c('div', {
    staticClass: "background-output",
    attrs: {
      "id": "background-output"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "background-vignette",
    attrs: {
      "id": "vignette"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "background-noise",
    attrs: {
      "id": "noise"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 centered"
  }, [_c('p', [_vm._v("Tu veux garder contact et suivre nos aventures.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 centered"
  }, [_vm._v("\n                     \n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "fb-root"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06cd61c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quizz.vue
// module id = 59
// module chunks = 0